import React from "react";
import { useNavigate } from "react-router-dom";
import { User, CalendarDays, ChevronRight } from "lucide-react";
import MessengerLayout from "../../layout/MessengerLayout";

// Staff Settings hub. Fulfils the Sidebar TODO ("point non-admins at a real
// settings page when one exists"). Hosts My profile and the new My diary.
const ITEMS = [
  { key: "profile", label: "My profile", desc: "Your personal and job details", to: "/messenger/profile", Icon: User },
  { key: "diary",   label: "My diary",   desc: "Your private daily check-ins, just for you", to: "/messenger/diary", Icon: CalendarDays },
];

export default function SettingsMessengerPage() {
  const navigate = useNavigate();
  return (
    <MessengerLayout>
      <div style={{ maxWidth: 640, margin: "0 auto", padding: "32px 16px" }}>
        <h2 style={{ color: "#fff", fontSize: 22, marginBottom: 20 }}>Settings</h2>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {ITEMS.map(({ key, label, desc, to, Icon }) => (
            <button
              key={key}
              onClick={() => navigate(to)}
              style={{ display: "flex", alignItems: "center", gap: 14, padding: "16px 18px", borderRadius: 14, border: "1px solid rgba(255,255,255,0.08)", background: "#0f1215", cursor: "pointer" }}
            >
              <Icon size={20} color="#00ff90" />
              <div style={{ flex: 1, textAlign: "left" }}>
                <div style={{ color: "#fff", fontSize: 15, fontWeight: 600 }}>{label}</div>
                <div style={{ color: "rgba(255,255,255,0.45)", fontSize: 13 }}>{desc}</div>
              </div>
              <ChevronRight size={18} color="rgba(255,255,255,0.4)" />
            </button>
          ))}
        </div>
      </div>
    </MessengerLayout>
  );
}
